import React from 'react';
import { Shield, Building, Server, Globe, MapPin } from 'lucide-react';
import { useDarkMode } from '../darkmode/DarkModeContext';

const BusinessSolutions = () => {
  const { isDarkMode } = useDarkMode();

  const solutions = [
    { icon: <Shield className="w-8 h-8" style={{ color: '#1E9B4C' }} />, title: "Keamanan Data", description: "Lindungi data bisnis Anda dengan solusi keamanan tingkat lanjut." },
    { icon: <Building className="w-8 h-8" style={{ color: '#1E9B4C' }} />, title: "Internet Dedicated", description: "Nikmati koneksi stabil dan cepat dengan layanan internet dedicated kami." },
    { icon: <Server className="w-8 h-8" style={{ color: '#1E9B4C' }} />, title: "Data Center", description: "Solusi hosting aman dan andal untuk semua kebutuhan data bisnis Anda." },
    { icon: <Globe className="w-8 h-8" style={{ color: '#1E9B4C' }} />, title: "VPN Bisnis", description: "Hubungkan kantor cabang dengan jaringan VPN yang aman dan terpercaya." },
    { icon: <MapPin className="w-8 h-8" style={{ color: '#1E9B4C' }} />, title: "Lokasi Global", description: "Dukungan jaringan luas untuk ekspansi bisnis Anda." }
  ];

  const stats = [
    { number: '500+', label: 'Perusahaan Terpercaya' },
    { number: '99.9%', label: 'Uptime Guarantee' },
    { number: '24/7', label: 'Technical Support' },
    { number: '10+', label: 'Tahun Pengalaman' }
  ];

  return (
    <div className={`py-16 transition-colors duration-300 ${isDarkMode ? 'bg-gradient-to-br from-gray-900 to-gray-800' : 'bg-[#F0FFF4]'}`}>
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Business Solutions
          </h2>
          <p className={`text-sm max-w-xl mx-auto ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Sediakan koneksi internet yang dapat diandalkan untuk bisnis Anda dengan Telnet Home.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Solutions Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {solutions.map((solution, index) => (
              <div
                key={index}
                className={`card-base p-5 text-center ${
                  isDarkMode
                    ? 'bg-gray-800 border border-gray-700'
                    : 'bg-white border border-gray-100'
                } ${index >= 3 ? 'sm:col-span-1' : ''}`}
              >
                <div className="flex justify-center mb-3">{solution.icon}</div>
                <h3 className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  {solution.title}
                </h3>
                <p className={`text-xs leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  {solution.description}
                </p>
              </div>
            ))}
          </div>

          {/* Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative max-w-sm w-full">
              <div className="bg-gradient-to-br from-[#1E9B4C] to-green-700 rounded-2xl p-0.5">
                <div className={`rounded-2xl overflow-hidden ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
                  <img src="image/businesssolution.png" alt="Business Professional" className="w-full h-auto object-cover" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {stats.map((stat, index) => (
            <div key={index} className={`card-base p-5 text-center ${isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-100'}`}>
              <div className="text-2xl md:text-3xl font-bold text-[#1E9B4C] mb-1">{stat.number}</div>
              <div className={`text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BusinessSolutions;
